import React from 'react';
import PropTypes from 'prop-types';
import {
  HighlightProvider,
  ContentDropdown,
  Image, 
  ZoomImageWrapper,
  PlainText,
  HighlightHTML
} from '@learningblocks/storybook-components';

import cn from './style.module.scss';

const TYPE_OBJECT = 'object';

/**
 * NotebookImage:
 *  - Component to display Images in Notebook [Experimental Designs]
 *  - Display Image with/without caption
 */
export function NotebookImage(props) {
  const className = `${cn.image} ${props.className} notebook-image-component`;
  // const {onPlainTextClick} = React.useContext(HighlightProvider.Context);
  // const onClickHighlight = (contentId, event) => {
  //   onPlainTextClick(contentId, event);
  // };

  if (typeof props.image === TYPE_OBJECT) {
    return (
      <figure className={className}>
        <Image src={props.image.src} alt={props.image.altText} width='100%' />
        <ZoomImageWrapper tabIndex={props.tabIndex} url={props.image.src} className={cn.zoomWrapper} />
        {/*<PlainText
          text={props.image.caption}
          onClickHighlight={onClickHighlight}
        />*/}
        <HighlightHTML
            key={props.id}
            content={props.image.caption}
            getContentData={props.getGlossaryItem}
            openGlossary={props.openGlossary}
        />
        {props.image.contentDropdown !== undefined ?
          <ContentDropdown
            contentDetails={props.image.contentDropdown}
          />
        : null}
      </figure>
    );
  } else {
    return (
      <>
        <Image
          width='100%'
          src={props.image}
          alt='notebook-figure'
          className={className}
          tabIndex={props.tabIndex}
        />
        <ZoomImageWrapper url={props.image} className={cn.zoomWrapper} />
      </>
    );
  }
}

NotebookImage.propTypes = {
  /**
   * tabIndex to set on component
   */
  tabIndex: PropTypes.number,
  /**
   *  ClassName
   */
  className: PropTypes.string,
  /**
   * Image to display
   *  - could be simply a url to image
   *  - or could be an object of type {src,caption}
   */
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      /**
       * Url to image
       */
      src: PropTypes.string,
      altText: PropTypes.string,
      /**
       * caption for image
       */
      caption: PropTypes.string,
    }),
  ]),
  /**
   * Callback for when Highlighted text is clicked,
   *  - Used in PlainText componnet which is used when image
   *    is displayed with caption.
   */
  onClickHighlight: PropTypes.func,
};

NotebookImage.defaultProps = {
  tabIndex: 0,
  className: '',
};
